<template>
  <aside class="pr-aside">
    <p class="pr-name">工业大数据监控系统</p>
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu :default-active="defaultActive()" @close="handleClose" @open="handleOpen" active-text-color="#ffd04b"
               background-color="#041527" class="el-menu-vertical-demo"
               router text-color="#fff">
        <el-menu-item index="/site-map" v-if="menuList && (menuList.includes('site-map') || menuList == 'all')">站点地图
        </el-menu-item>
        <el-menu-item index="/real-data" v-if="menuList && (menuList.includes('real-data') || menuList == 'all')">实时监控
        </el-menu-item>
        <el-menu-item index="/history-data" v-if="menuList && (menuList.includes('history-data') || menuList == 'all')">历史数据
        </el-menu-item>
        <el-menu-item index="/white-board" v-if="menuList && (menuList.includes('white-board') || menuList == 'all')">大屏白板
        </el-menu-item>
        <el-menu-item index="/device-control" v-if="menuList && (menuList.includes('device-control') || menuList == 'all')">设备控制
        </el-menu-item>
        <el-menu-item index="/alarm-data" v-if="menuList && (menuList.includes('alarm-data') || menuList == 'all')">报警数据
        </el-menu-item>
        <el-menu-item index="/statistical-overview" v-if="menuList && (menuList.includes('statistical-overview') || menuList == 'all')">流量统计总览
        </el-menu-item>
        <el-menu-item index="/statistical-data" v-if="menuList && (menuList.includes('statistical-data') || menuList == 'all')">流量统计报表
        </el-menu-item>
<!--        <el-menu-item index="/big-screen" v-if="companyId == '1' || companyId == '96'">大屏监控</el-menu-item>-->
        <el-menu-item index="/param-group-statistical" v-if="menuList && (menuList.includes('param-group-statistical') || menuList == 'all')">站点分组统计</el-menu-item>
      </el-menu>
    </el-scrollbar>
  </aside>
</template>
<script>
export default {
  name: "asideBar",
  props: {},
  components: {},
  data() {
    return {
      menuList: '',
      companyId: 0
    }
  },
  watch: {},
  created() {
    this.menuList = localStorage.getItem('gasHomeMenuList') // 登陆之后的 菜单权限
    this.companyId = localStorage.getItem('companyId')
    console.log('this.menuList----------', this.menuList)
  },
  mounted() {
  },
  methods: {

    handleOpen(key, keyPath) {
      console.log('handleOpen---------', key, keyPath);
    },

    handleClose(key, keyPath) {
      console.log('handleClose----------', key, keyPath);
    },

    defaultActive() {
      const path = this.$route.path
      console.log('path-----', path)
      return path
    }
  },
};
</script>
<style lang="scss" scoped="scoped">
.pr-aside {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  width: 210px;
  background-color: rgb(4, 21, 39);
}

.pr-name {
  padding: 15px 0 12px 20px;
  color: #fff;
  border-bottom: 1px solid #dcdcdc;
}

.el-scrollbar {
  height: 100%;
}

.el-menu {
  border: none;
}

::v-deep .el-scrollbar__wrap {
  overflow-x: hidden;
}

.is-active .is-active {
  background: #4290f7 !important;
}
</style>
